<template>
  <div class="date-field">
    <v-menu
      :close-on-content-click="false"
      :nudge-right="40"
      ref="menuFecha"
      v-model="menuFecha"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
      :disabled="disabled || readonly"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          v-model.trim="fechaFormateado"
          readonly
          :required="required"
          :error-messages="errorMessages"
          :label="required ? `${label}*` : label"
          persistent-hint
          autocomplete="off"
          append-icon="event"
          @blur="fechaIngreso = parseDate(fechaFormateado)"
          :name="name"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="fecha"
        no-title
        locale="es"
        ref="fechaPicker"
        :readonly="readonly"
        @input="menuFecha = false"
      >
        <v-btn text color="primary" @click="menuFecha = false">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="fecha = null; menuFecha = false">
          Borrar
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import fieldMixin from "./mixins/fieldMixin";

export default {
  name: "DateField",
  mixins: [fieldMixin],
  model: {
    prop: "fecha",
    event: "input",
  },
  data: () => ({
    menuFecha: false,
    fechaFormateado: null,
    fecha: null,
  }),
  methods: {
    formatDate(date, soloMes = false) {
      if (!date) return null;

      if (soloMes) {
        const [year, month] = date.split("-");
        return `${month}/${year}`;
      }
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date, soloMes = false) {
      if (!date) return null;
      if (soloMes) {
        const [month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}`;
      }

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    dateOperation() {
      let fechaSplit = this.value ? this.value.split("T") : [];
      this.fecha = fechaSplit[0] || "";
    },
  },
  mounted() {
    this.dateOperation();
  },
  watch: {
    fecha() {
      this.fechaFormateado = this.formatDate(this.fecha);
      this.$emit("input", this.fecha);
    },
    value() {
      this.dateOperation();
    },
  },
};
</script>

<style scoped></style>
